// React
import { useEffect, useRef, useState } from "react";

// i18n
import { useTranslation } from "react-i18next";

// Prime React
import { OverlayPanel } from "primereact/overlaypanel";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { MultiSelect } from "primereact/multiselect";

const SelectDaysFilter = (props: any) => {
  const toast = useRef<any>(null);
  const { t } = useTranslation();
  const selectDaysDpDown = useRef<any>(null);
  const [selectedDays, setSelectedDays] = useState<any>("");
  const [ToastMessage, setToastMessage] = useState<any>("");
  const selectDaysDpDownDateRange = useRef<any>(null);
  const [date2, setDate2] = useState<any>(props.chosenDayDateRange);

  const [calendarHideState, UpdateCalendarHideState] = useState(false);
  let session = window.localStorage;
  const selectDaysList = [
    { name: " \u00A0 Last 30 days", key: "A" },
    { name: "\u00A0 Last 90 days", key: "M" },
    { name: "\u00A0 Last 12 Months", key: "P" },
  ];

  useEffect(() => {
    session.setItem("summary_filter_days", "P");
    setSelectedDays("P");
    setDate2(props.chosenDayDateRange);
  }, []);

  useEffect(() => {
    if (ToastMessage != "") {
      toast?.current?.show({
        severity: "error",
        summary: "Error message",
        detail: ToastMessage,
        life: 10000,
      });
      setToastMessage("");
    }
  }, [ToastMessage]);
  let maxDate = new Date();
  const onSelectDaysChange = (e: any) => {
    if (e?.value?.key) {
      session.setItem("summary_filter_days", e?.value?.key);
      session.setItem("summary_filter_range_flag", "");
      setSelectedDays(e?.value?.key);
      props?.setChosenDay(e?.value?.key);
      props.setchosenDayDateRange("");
      setDate2(null);
    }
  };
  
  return (
    <>
      <Toast ref={toast} />
      {/* , backgroundColor: "white", color: "#607D8B", border: "1px solid #ccc" */}

      <button
        className="DashboardFilterButton"
        style={{
          fontWeight: "500",
          height: "30px",
          borderRadius: "3px",
          backgroundColor: "#265B6B",
          color: "white",
          border: "1px solid #265B6B",
          fontSize: "12px",
        }}
        onClick={(e) => selectDaysDpDown.current.toggle(e)}
      >
        <i className="pi pi-calendar-plus" />
        &nbsp;{"Timeframe"}
      </button>

      <OverlayPanel ref={selectDaysDpDown}>
        {selectDaysList.map((msp) => {
          return (
            <div key={msp.key} className="flex align-items-center mt-2">
              <Checkbox
                inputId={msp.key}
                name="msp"
                value={msp}
                onChange={(e: any) => {
                  onSelectDaysChange(e);
                  selectDaysDpDown.current.toggle(e);
                }}
                checked={props?.chosenDay == msp.key || selectedDays == msp.key}
                onClick={(e) => {}}
              />
              <label htmlFor={msp.key} className="ml-2">
                {msp.name}
              </label>
            </div>
          );
        })}
        <hr style={{ border: "1px solid" }} />
        <div className="flex align-items-center mt-2">
          <i className="pi pi-plus"></i>
          <label
            htmlFor={"Custom-date-range"}
            className="ml-2"
            onClick={(e) => {
              selectDaysDpDownDateRange.current.toggle(e);
              UpdateCalendarHideState(true);
            }}
            style={{ cursor: "pointer" }}
          >
            {t(" \u00A0Custom Date Range")}
          </label>
        </div>

        {(session.getItem("summary_filter_range_flag") != "" ||
          session.getItem("summary_filter_days") != "") && (
          <div className="flex align-items-center mt-2"></div>
        )}
      </OverlayPanel>
      <OverlayPanel ref={selectDaysDpDownDateRange}>
        <Calendar
          visible={calendarHideState}
          onHide={() => {
            UpdateCalendarHideState(false);
          }}
          inline
          id="range"
          value={date2}
          maxDate={maxDate}
          onChange={(e: any) => {
            setDate2(e.value);
            if (e.value[1] != null) {
              let tempSdate: any = new Date(e.value[0]);
              let tempEdate: any = new Date(e.value[1]);
              const diffTime = Math.abs(tempEdate - tempSdate);
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

              let startD = new Date(e.value[0]);
              let EndD = new Date(e.value[1]);

              let anomalyDetectionFilterStartDate = startD.toISOString();
              let anomalyDetectionFilterEndDate = EndD.toISOString();

              props.setchosenDayDateRange(e.value);
              setSelectedDays("");
              session.setItem("summary_filter_days", "");
              session.setItem("summary_filter_range_flag", "ok");
              props?.setChosenDay("");
              UpdateCalendarHideState(false);
              selectDaysDpDownDateRange.current.toggle(e);
            }
          }}
          selectionMode="range"
        />
      </OverlayPanel>
    </>
  );
};

export default SelectDaysFilter;
